import { DEAL_ACTIVITY } from './dealActivity';
import { DEAL_CONTACTS } from './dealContacts';
import { DEAL_ACTIVITIES } from './dealActivities';
import { DEAL_ACTIVITY_COUNT } from './dealActivityCount';
import { CREATE_DEAL_ACTIVITY } from './createDealActivity';
import { UPDATE_DEAL_ACTIVITY } from './updateDealActivity';
import { DELETE_DEAL_ACTIVITY } from './deleteDealActivity';
import { DELETE_DEAL_ACTIVITIES } from './deleteDealActivities';

import { SMS_CONVERSATION } from './smsConversation';
import { VO_CONTACTS } from './voContacts';
import { CREATE_SMS_ACTIVITY } from './createSmsActivity';
import { MARK_SMS_ACTIVITIES_READ } from './markSmsActivitiesRead';

export * from './useDealActivityMutations';
export * from './useFetchActivityList';

// Customer Activity Hub list query (modules/customers). Referenced by operation name to avoid a circular import.
export const CUSTOMER_DEAL_ACTIVITIES_QUERY_NAME = 'CustomerDealActivities';

export const dealActivityApi = {
  dealContacts: DEAL_CONTACTS,
  dealActivity: DEAL_ACTIVITY,
  dealActivities: DEAL_ACTIVITIES,
  dealActivityCount: DEAL_ACTIVITY_COUNT,

  create: CREATE_DEAL_ACTIVITY,
  update: UPDATE_DEAL_ACTIVITY,
  delete: DELETE_DEAL_ACTIVITY,
  deleteMultiple: DELETE_DEAL_ACTIVITIES,

  voContacts: VO_CONTACTS,
  smsConversation: SMS_CONVERSATION,
  createSmsActivity: CREATE_SMS_ACTIVITY,
  markSmsActivitiesRead: MARK_SMS_ACTIVITIES_READ,
};
